import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import axios from "axios"

import Grid from "@material-ui/core/Grid"

import VisaRequestDetails from "../common/visa/visa-request-details"
import VisaAppliedOffers from "../common/visa/visa-applied-offers"
import VisaOfferForm from "../common/visa/visa-offer-form"
import VisaRequestChips from "../common/visa/visa-request-chips"
import RequestDetailsSkeleton from "../common/skeleton/request-details-skeleton"
import RequestInfoSkeleton from "../common/skeleton/request-info-skeleton"
import RequestOfferSkeleton from "../common/skeleton/request-offer-skeleton"
import RequestInfo from "../common/request/request-info"
import RequestPreview from "../common/request/request-preview"
import { Panel, PanelHeader, PanelContent } from "../common/panel"

import { checkTokenExpirationMiddleware } from "../../../middlewares/users-auth.middleware"

const VisaRequest = () => {
  let { id } = useParams()
  const [reservationRequest, setReservationRequest] = useState(null)
  const [loading, setLoading] = useState(true)
  const [, setError] = useState(null)
  const [reloadOffers, setReloadOffers] = useState(null)
  const [user] = useState(checkTokenExpirationMiddleware())
  let headers = {
    Authorization: `Bearer ${user.Token}`
  }
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/api/requests/${id}?q=visa`, { headers: headers })
      .then(res => {
        setReservationRequest(res.data)
        setTimeout(() => setLoading(false), 750)
      })
      .catch(err => {
        setError({ error: "Error Loading page" })
      })
  }, [])

  const handleReloadOffers = () => {
    let reload = { ...reloadOffers }
    setReloadOffers(reload)
  }

  return (
    <>
      <Grid container spacing={3}>
        <Grid container item xs={12} md={12} lg={9}>
          <Panel>
            <PanelHeader>Request Details</PanelHeader>
            <PanelContent>{loading ? <RequestDetailsSkeleton /> : reservationRequest ? <RequestPreview label={"Visa"} keyword={"Cities"} reservationRequest={reservationRequest} Details={<VisaRequestDetails visaResources={reservationRequest.reservationRequestVisaResources} />} Chips={<VisaRequestChips variant={"default"} customClasses={"contain-success"} visaResources={reservationRequest.reservationRequestVisaResources} />} /> : null}</PanelContent>
          </Panel>

          <Panel>
            <PanelHeader>My Offers</PanelHeader>
            <PanelContent>{reservationRequest ? <VisaAppliedOffers reloadOffers={reloadOffers} reservationReqId={reservationRequest.id} /> : null}</PanelContent>
          </Panel>

          <Panel>
            <PanelHeader>Add An Offer</PanelHeader>
            <PanelContent>{loading ? <RequestOfferSkeleton /> : reservationRequest ? <VisaOfferForm handleReloadOffers={handleReloadOffers} reservationReqId={reservationRequest.id} /> : null}</PanelContent>
          </Panel>
        </Grid>

        <Grid container item xs={12} md={12} lg={3}>
          <div className="side-info">{loading ? <RequestInfoSkeleton /> : reservationRequest ? <RequestInfo reservationRequest={reservationRequest} /> : null}</div>
        </Grid>
      </Grid>
    </>
  )
}

export default VisaRequest
